import React from 'react';

import Question from '../elements/question';
import Feedback from '../elements/feedback';
import {SubsidieBox, WarningBox} from '../elements/infoboxes'
import state from '../zviz3/state';
import { ConnectState } from '../zviz3/Connect';
import { checkConditions } from '../helpers/conditions';
import Icon from '../elements/icon';

const getSquareMeters = function(){
    const houseType = state.get('answers.a4');
    if(houseType==='vrijstaand'){
        return 15;
    }else if(houseType==='halfvrijstaand'){
        return 12;
    }else if(houseType==='tussenwoning'){
        return 10;
    }else if(houseType==='etagewoning'){
        return 8;
    }
    return 'de vereiste ';
}

const questions = [
    {
        name: 'e1',
        question: 'Kiest u voor HR++ glas als nieuwe beglazing in de bestaande buitengevel?',
        explanation: "Met HR++ glas wordt dubbel glas met 2 isolatielagen bedoeld. Heeft u triple-glas toegepast, vul hier \"nee\" in, u krijgt een aparte vraag over triple-glas",
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [ 
            {variable: 'd', value: true, type: 'equal'}
        ]
    },
    {
        name: 'e2',
        question: 'Voldoet het gebruikte glas aan de gestelde voorwaarden?',
        explanation: 'Het gebruikte glas mag een U-waarde van maximaal 1,2 W/m\u00b2K hebben om in aanmerking te komen. De U-waarde (vroeger de K-waarde) drukt de hoeveelheid warmte uit die per m² tussen de ene en de andere zijde van een wand, ruit of andere constructie doorgelaten wordt. De U-waarde wordt ook wel warmtedoorgangscoëfficiënt genoemd. Controleer bij de fabrikant of uitvoerder of U-waarde van het gebruikte materiaal aan de eisen voldoet.',
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'e1', value: true, type: 'equal'}
        ]
    },
    {
        name: 'e3',
        question: () => ('Is het aantal vierkante meter glas dat u heeft vervangen in de bestaande buitengevel meer dan ' + getSquareMeters() + 'm\u00b2?'),
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'e2', value: true, type: 'equal'}
        ]
    },
    {
        name: 'e4',
        question: () => ('Is het oppervlak van alle ruiten in uw woning minder dan ' + getSquareMeters() + 'm\u00b2?'),
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'e3', value: false, type: 'equal'},
        ]
    },
    {
        name: 'e5',
        question: 'Kiest u voor triple-glas als nieuwe beglazing in de bestaande buitengevel?',
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'e4', value: null, type: 'not_equal'},
            {variable: 'e3', value: true, type: 'equal'},
            {variable: 'e1', value: false, type: 'equal'},
            {variable: 'e2', value: false, type: 'equal'}
        ]
    },
    {
        name: 'e6',
        question: 'Voldoet het triple-glas aan de gestelde voorwaarden?',
        explanation: 'Het gebruikte glas mag een U-waarde van maximaal 0,7 W/m\u00b2K hebben om in aanmerking te komen. De U-waarde (vroeger de K-waarde) drukt de hoeveelheid warmte uit die per m² tussen de ene en de andere zijde van een wand, ruit of andere constructie doorgelaten wordt. De U-waarde wordt ook wel warmtedoorgangscoëfficiënt genoemd. Controleer bij de fabrikant of uitvoerder of U-waarde van het gebruikte materiaal aan de eisen voldoet.',
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'e5', value: true, type: 'equal'}
        ]
    },
    {
        name: 'e7',
        question: 'Heeft u ook de kozijnen vervangen door een isolerend kozijn dat voldoet aan de gestelde voorwaarden?',
        explanation: 'Het kozijn mag een U-waarde van maximaal 1,5 W/m\u00b2K hebben om in aanmerking te komen. De U-waarde (vroeger de K-waarde) drukt de hoeveelheid warmte uit die per m² tussen de ene en de andere zijde van een wand, ruit of andere constructie doorgelaten wordt. De U-waarde wordt ook wel warmtedoorgangscoëfficiënt genoemd. Controleer bij de fabrikant of uitvoerder of U-waarde van het gebruikte materiaal aan de eisen voldoet.',
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'e6', value: true, type: 'equal'}
        ]
    },
    // {
    //     name: 'e8',
    //     question: 'Heeft het nieuwe kozijn een U-waarde van maximaal 1,5 W/m\u00b2K?',
    //     explanation: null,
    //     options: [
    //         {value: true, label: 'Ja'},
    //         {value: false, label: 'Nee'}
    //     ],
    //     conditions: [
    //         {variable: 'e7', value: true, type: 'equal'}
    //     ]
    // },
    {
        name: 'e9',
        question: () => ('Is het aantal vierkante meter glas dat u heeft vervangen in de bestaande buitengevel meer dan ' + getSquareMeters() + 'm\u00b2?'),
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'e7', value: true, type: 'equal'}
        ]
    },
    {
        name: 'e10',
        question: () => ('Is het totale oppervlakte aan glas in uw gehele woning minder dan ' + getSquareMeters() + 'm\u00b2?'),
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'e9', value: false, type: 'equal'},
        ]
    }
]

const condHR = [
    {variable: 'e3', value: true, type: 'equal'},
    {variable: 'e4', value: true, type: 'equal'}
];
const condTriple = [
    {variable: 'e9', value: true, type: 'equal'},
    {variable: 'e10', value: true, type: 'equal'}
];

const concludedQuestions = [
    {variable: 'e5', value: false, type: 'equal'},
    {variable: 'e6', value: false, type: 'equal'},
    {variable: 'e7', value: false, type: 'equal'},
    // {variable: 'e8', value: false, type: 'equal'},
    {variable: 'e9', value: true, type: 'equal'},
    {variable: 'e10', value: null, type: 'not_equal'}   
];

export const getSubsidies = function(){
    let text = [];
    if(checkConditions(condHR)){
        text.push("HR++glas € 35 per m\u00b2, panelen met dezelfde U-waarde als het glas in hetzelfde kozijn € 15 per m\u00b2");
    }
    if(checkConditions(condTriple)){
        text.push("Triple-glas € 100 per m\u00b2; panelen met dezelfde U-waarde als triple glas in hetzelfde kozijn € 75 per m\u00b2");
    }
    return text;
}

const feedback = [
    {
        content: () => ( <SubsidieBox text={getSubsidies()} /> ),
        name: 'e',
        value: true,
        conditions: [
            {type: 'and', conditions: [
                // conditions to match to get the subsidy
                {type: 'group', conditions: [...condHR, ...condTriple]},

                // set of conditions to identify that the question has concluded
                {type: 'group', conditions: concludedQuestions},
            ]}
        ]    
    },

    {
        content: <WarningBox text="U komt niet in aanmerking voor subsidie voor isolerend glas" />,
        name: 'e',
        value: true,
        conditions: [
            {type: 'and', conditions: [
                // condition the question has concluded
                {type: 'group', conditions: concludedQuestions},

                // condition, we do not have a success
                {type: 'nor', conditions: [...condHR, ...condTriple]}
            ]},
        ]    
    },
];

const sectionConditions = [
    {type: 'and', conditions: [
        {variable: 'a6', value: 'glas', type: 'includes'},
        {variable: 'b', value: true, type: 'equal'},
        {variable: 'c', value: true, type: 'equal'},
        {variable: 'd', value: true, type: 'equal'}
    ]}
];

function SectionE(props){

    if(checkConditions(sectionConditions)){
        return <div className="seehi_section">
            <h2 className="seehi_iconHeader"><Icon type="glas" />Glas</h2>
            <p>Als u de beglazing in uw woning heeft vervangen door hoogrendementsglas, heeft u mogelijk recht op subsidie.</p>

            {questions.map((props, i) => ( <Question key={i} {...props} /> ))}
        
            {feedback.map((props, i) => ( <Feedback key={i} {...props} /> ))}
            
        </div>;
    }

    return '';
}

export default ConnectState(SectionE, 'answers');



// WEBPACK FOOTER //
// ./src/sections/e.js